import GlobalNavigationShell from "components/v2/global-navigation-shell/GlobalNavigationShell";
import SharedNavigation from "components/v2/shared-navigation/SharedNavigation";
import useDesktopChecker from "hooks/useDesktopChecker";
import useTabletChecker from "hooks/useTabletChecker";
import Application from "pages/application/Application";
import { getStepData } from "pages/application/question/questionSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SectionBar from "components/v2/section-bar/SectionBar";
import { closeProfile, getActiveTab, getProfileSettings, setProfileActiveTab } from "features/authSlice";
import ProfileSettings from "pages/dashboard/v2/shared/profile-settings/ProfileSettings";
import "./shared-layout/shared-layout.scss";

const ApplicationRoute = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDesktop = useDesktopChecker();
  const isTablet = useTabletChecker();
  const isMobilePhone = !isDesktop && !isTablet;
  const { section: activeSection, sections } = useSelector(getStepData);
  const activeTab = useSelector(getActiveTab);
  const showProfile = useSelector(getProfileSettings);

  useEffect(() => {
    dispatch(closeProfile());
  }, [dispatch]);

  const handleMobileTabChange = (tab: string) => {
    dispatch(setProfileActiveTab(tab));
    navigate("/dashboard");
  };

  const content = showProfile ? (
    <div className={isDesktop ? "application-profile-settings-wrapper" : "application-profile-settings-mobile"}>
      <ProfileSettings />
    </div>
  ) : (
    <Application />
  );

  const shellWrapperClassName = isDesktop
    ? "application-layout-context application-shell"
    : "application-shell application-shell--mobile";

  return (
    <div className={shellWrapperClassName}>
      <GlobalNavigationShell
        notificationsEnabled={false}
        navSlot={
          !isMobilePhone ? <SectionBar activeSection={activeSection} sections={sections} /> : undefined
        }
        navSlotPlacement="sidebar"
        mobileNavSlot={
          isMobilePhone ? (
            <SharedNavigation
              activeTab={activeTab}
              onTabChange={handleMobileTabChange}
              isDesktop={false}
              isTablet={false}
              isNavOpen={false}
              setIsNavOpen={() => undefined}
            />
          ) : undefined
        }
      >
        {content}
      </GlobalNavigationShell>
    </div>
  );
};

export default ApplicationRoute;
